(() => {
  if (window.__aaReliablePricePopup) return;
  window.__aaReliablePricePopup = true;
  let activeButton = null;
  const dialog = document.createElement('div');
  dialog.className = 'aa-price-dialog';
  dialog.setAttribute('role','dialog');
  dialog.setAttribute('aria-modal','false');
  dialog.setAttribute('aria-label','Price reduction information');
  dialog.setAttribute('hidden','');
  dialog.innerHTML = '<button type="button" class="aa-price-dialog__close" aria-label="Close price information">&times;</button><div class="aa-price-dialog__content"></div>';
  function mount() { if (!dialog.isConnected && document.body) document.body.appendChild(dialog); }
  function close(returnFocus=false) {
    if (dialog.hasAttribute('hidden')) return;
    dialog.setAttribute('hidden','');
    if (activeButton) {
      activeButton.setAttribute('aria-expanded','false');
      if (returnFocus && activeButton.isConnected) activeButton.focus({preventScroll:true});
    }
    activeButton = null;
  }
  function position() {
    if (!activeButton || dialog.hasAttribute('hidden')) return;
    const rect = activeButton.getBoundingClientRect();
    const w = dialog.offsetWidth, h = dialog.offsetHeight;
    const vw = document.documentElement.clientWidth, vh = window.innerHeight;
    const left = Math.max(12, Math.min(rect.left + rect.width / 2 - w / 2, vw - w - 12));
    let top = rect.bottom + 10;
    if (top + h > vh - 12 && rect.top - h - 10 >= 12) top = rect.top - h - 10;
    top = Math.max(12, Math.min(top, vh - h - 12));
    dialog.style.left = left + 'px';
    dialog.style.top = top + 'px';
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mf-price-info]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      if (trigger === activeButton) { close(true); return; }
      close();
      mount();
      const content = dialog.querySelector('.aa-price-dialog__content');
      const existing = trigger.closest('.mf-price-design')?.querySelector('[data-mf-price-popup]');
      if (existing) {
        content.innerHTML = '';
        const title = existing.querySelector('.mf-price-design__popup-title');
        const paragraphs = existing.querySelectorAll('p, .mf-price-design__popup-saving');
        if (title) { const h = document.createElement('div'); h.className = 'aa-price-dialog__title'; h.textContent = title.textContent.trim(); content.appendChild(h); }
        paragraphs.forEach(p => content.appendChild(p.cloneNode(true)));
      } else {
        content.innerHTML = '';
        const title = document.createElement('div'); title.className = 'aa-price-dialog__title'; title.textContent = 'Price reduction information';
        const p = document.createElement('p'); p.textContent = 'Previous price: ' + (trigger.dataset.compare || '—') + '. Current price: ' + (trigger.dataset.price || '—') + '.';
        const saving = document.createElement('p'); saving.textContent = 'You save ' + (trigger.dataset.saving || '—') + ' compared with the previous price shown.';
        content.append(title,p,saving);
      }
      activeButton = trigger;
      trigger.setAttribute('aria-expanded','true');
      dialog.removeAttribute('hidden');
      position();
      return;
    }
    if (event.target.closest('.aa-price-dialog__close')) { close(true); return; }
    if (!event.target.closest('.aa-price-dialog')) close();
  }, true);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !dialog.hasAttribute('hidden')) { e.preventDefault(); close(true); } });
  window.addEventListener('resize', () => { if (activeButton) position(); }, {passive:true});
  window.addEventListener('scroll', () => close(), {passive:true, capture:true});
})();
